import React from "react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import { setPage } from "../../../../stores/WashingStore/WashingStore";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";
import { TextContainer, Title, Footer } from "./StartPageStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemWashingStyles";

const StartPage: React.FC = () => {
  const handleNext = () => {
    setPage(PAGES.CHOOSE_LICENCE);
  };

  return (
    <GradientContainer onClick={handleNext}>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Title>ECONOMIZA</Title>
        <Subtitle>TEMPO | DINHEIRO</Subtitle>
      </TextContainer>
      <Footer>Toque na tela para iniciar atendimento...</Footer>
    </GradientContainer>
  );
};

export default StartPage;
